import { render, staticRenderFns } from "./CouponAssociation.html?vue&type=template&id=b10202d2&scoped=true&external"
import script from "./CouponAssociation.vue?vue&type=script&lang=js"
export * from "./CouponAssociation.vue?vue&type=script&lang=js"
import style0 from "./CouponAssociation.scss?vue&type=style&index=0&id=b10202d2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10202d2",
  null
  
)

export default component.exports